import { useSelector } from 'react-redux';
import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import { QueryBaseComponent } from '../../../../../../../react-commons/query/QueryBaseComponent';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    ActivitiesMutationResourceSchema,
    ActivitiesPropertyValidation,
    defaultActivitiesResource,
    useActivitiesActions,
} from '../../../../../resource/resources/artifacts/activities/activitiesResource';
import { Form_DisplayComponentBaseView } from '../../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { SingleParentedOverviewComponent } from '../../../../reusable-components/resource-overviews/SingleParentedOverviewComponent';
import { selectNoScopeValidationScope, selectReadOnly } from '../../../../util/useSelectorFunctions';
import { ActivityContent } from './ActivityContent';

const ActivitiesOverviewContent = ({ id, displayedInOverview }: { id: string; displayedInOverview: boolean }) => {
    const readOnly = useSelector(selectReadOnly);

    const activitiesActions = useActivitiesActions();
    const activitiesQuery = activitiesActions.useGetResource(id);
    const updateActivities = activitiesActions.useUpdateResource();

    const { form, formNames, onSubmit } = useMyForm({
        schema: ActivitiesMutationResourceSchema,
        defaultValues: defaultActivitiesResource,
        submitHandler: async (data) => {
            await updateActivities.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: activitiesQuery.data,
    });

    return (
        <QueryBaseComponent name="Activities" query={activitiesQuery}>
            <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={false}>
                <ActivityContent
                    displayedInOverview={displayedInOverview}
                    form={form}
                    formNames={formNames}
                    readOnly={readOnly}
                    id={id}
                />
            </Form_DisplayComponentBaseView>
        </QueryBaseComponent>
    );
};

export const ActivityOverviewComponent = ({ parentId }: { parentId: string }) => {
    const validationScope = useSelector(selectNoScopeValidationScope);

    const activitiesActions = useActivitiesActions();

    const parametersQuery = activitiesActions.useGetAllResources(parentId);

    const resourceType = ResourceType.ACTIVITIES;

    return (
        <QueryBaseComponent name="Activities" query={parametersQuery}>
            <SingleParentedOverviewComponent
                label={'Activities'}
                resourceQuery={parametersQuery}
                content={(id, displayedInOverview) => (
                    <ActivitiesOverviewContent id={id} displayedInOverview={displayedInOverview} />
                )}
                propertyValidationInformation={{
                    namePropertyIdentifier: ActivitiesPropertyValidation.NAME,
                    resourceType,
                }}
                validationScope={validationScope}
                parentId={parentId}
            />
        </QueryBaseComponent>
    );
};
